// Cost levers for the post queries (see docs/plans/firestore-cost-scaling.md).

// Map observation layer: only show posts from the last N days. Old
// observations age off the map (they stay in feed/threads/deep links).
// Widened 30 → 120 in June 2026 while content volume is low so early
// posts keep the map populated; tighten again as posting picks up.
export const MAP_POSTS_WINDOW_DAYS = 120;

// Cap on the map layer's live query. Every map session pays the full
// result set as Firestore reads, so this is a direct $/session read-cost
// bound, not a display limit — raise with care.
//
// 500 -> 1000 in July 2026: dev held 577 public posts inside the 120-day
// window, so the cap bound and everything older than the 500th newest was
// dropped off the map with no sign to the user beyond the [map-cap] warning
// in posts.ts. Headroom, not a fix — the query still pulls the newest N
// sitewide with no viewport bound, so this buys time rather than scaling.
// The real fix is a geohash-bounded query (posts already store
// location.geohash and the structure layer already loads by viewport):
// docs/plans/map-posts-viewport-query.md, due before the prod cutover.
export const MAP_POSTS_LIMIT = 1000;

// Feed focus-refetch staleness gate: skip the automatic refetch when the
// last successful fetch is younger than this. Manual pull-to-refresh
// always bypasses the gate.
export const FEED_STALE_MS = 2 * 60 * 1000;

// Page size for the feed's paginated getFeed query. Lives here (rather than
// as a private const in src/api/posts.ts) so FEED_LIVE_LIMIT below can share
// it instead of duplicating the number.
export const POSTS_PER_PAGE = 20;

// Cap on the feed's live subscription (subscribeFeed) — mirrors one page of
// the paginated feed so the live head and the paginated tail line up at the
// same cursor depth.
export const FEED_LIVE_LIMIT = POSTS_PER_PAGE;
